// CountUp import REMOVED — previously used for inline monthly rent display.
// Now replaced by a ResultsBadge which handles its own formatting.
// Previously: import CountUp from "react-countup";
import CallToActions from "./CallToActions";
import ResultsBadge from "./widgets/ResultsBadge";

// ---------------------------------------------------------------------------
// RentToMortgageResults.jsx
//
// LAYOUT UPDATE: Single inner gradient box inside one outer white card.
//
// Previously: two separate inner gray gradient boxes with an "Affordability"
// heading between them.
//
// Now: one outer frost card containing ONE inner gray gradient box.
// The "Affordability" heading has been removed. All results are merged
// into the single box.
//
//   Outer card
//     └── Inner box — all results
//           You currently pay (bold text)
//           Monthly rent (bold inline CountUp)
//           Equivalent mortgage (text-lg)
//           Monthly capital and interest — plain white badge
//           Monthly interest only        — plain white badge
//           Minimum income required      — plain white badge
//           Estimated mortgage amount    — filled blue badge
// ---------------------------------------------------------------------------

function RentToMortgageResults({ results, onReset }) {
  const [estimatedMortgage, minimumIncome, monthlyRepayment, monthlyInterest] =
    results;

  return (
    <div className="frost relative z-10 w-full rounded-lg border border-gray-200 bg-white p-4 shadow-xl shadow-purple-500/25 dark:border-gray-800 dark:bg-black dark:shadow-purple-500/50 md:-mt-32">
      {/* CHANGED: mb-8 removed from outer div — grid gap-8 in RentToMortgagePage.jsx
          handles row spacing between all three cards uniformly.
          Previously: <div className="frost relative z-10 mb-8 w-full ..."> */}
      {/* MOBILE FIX: -mt-24 and sm:-mt-32 removed — caused results card to overlap form card
          when stacked on mobile. Negative margin now only applies at md+ (desktop side-by-side)
          where it correctly pulls the card up into the hero.
          Previously: className="frost ... -mt-24 ... sm:-mt-32" */}
      {/* ------------------------------------------------------------------ */}
      {/* SINGLE INNER BOX — all results merged                              */}
      {/* LAYOUT CHANGE: Previously two separate inner gray gradient boxes   */}
      {/* with an "Affordability" h3 heading between them.                  */}
      {/* Now: one box containing all content; heading removed.             */}
      {/* Previously:                                                        */}
      {/*   <div className="mb-4 rounded-lg border ..."> ...box 1... </div> */}
      {/*   <h3 ...>Affordability</h3>                                       */}
      {/*   <div className="mb-4 rounded-lg border ..."> ...box 2... </div> */}
      {/* ------------------------------------------------------------------ */}
      <div className="mb-4 rounded-lg border border-gray-400 bg-gradient-to-tl from-gray-100 p-3 dark:border-gray-600 dark:bg-gray-900 dark:from-gray-900">
        {/* DISPLAY CHANGE: white ResultsBadge → plain text-lg paragraph with bold figure
            Previously:
              <ResultsBadge size="small" colorScheme={null} result={monthlyRepayment} label="Your current monthly rent" ... /> */}
        <p className="mb-4 text-lg text-black dark:text-white">
          Your current monthly rent{" "}
          <span className="font-bold">
            £{monthlyRepayment.toLocaleString()}
          </span>
        </p>

        {/* DISPLAY CHANGE: plain "Equivalent mortgage" → sentence including monthly repayment figure
            "Monthly capital and interest" badge REMOVED
            "Monthly interest only" badge REMOVED
            Previously:
              <p className="mb-2 text-lg ...">Equivalent mortgage</p>
              <ResultsBadge label="Monthly capital and interest" ... />
              <ResultsBadge label="Monthly interest only" ... /> */}
        {/* DISPLAY CHANGE: "Equivalent mortgage with a monthly capital of £X, including interest" (text paragraph)
            → "Monthly mortgage Payment (repayment terms)" label + white ResultsBadge
            Previously:
              <p className="mb-4 text-lg ...">Equivalent mortgage with a monthly capital of <span className="font-bold">£{monthlyRepayment.toLocaleString()}</span>, including interest</p> */}
        <ResultsBadge
          size="small"
          format="price"
          colorScheme={null}
          result={monthlyRepayment}
          label="Monthly mortgage Payment (repayment terms)"
          last={false}
        />

        {/* ORDER CHANGE: Estimated mortgage (blue badge) moved above Minimum income (white badge)
            Previously: Minimum income first, Estimated mortgage second */}

        {/* Filled blue badge — primary result */}
        {/* LABEL CHANGE: "Estimated mortgage amount" → "Potential mortgage loan available"
            Previously: label="Estimated mortgage amount" */}
        <ResultsBadge
          size="large"
          format="price"
          colorScheme={2}
          result={estimatedMortgage}
          label="Potential mortgage loan available"
          help={
            <p className="text-md text-white">
              The estimated property value you could borrow, calculated by
              treating your monthly rent as the mortgage repayment and
              reverse-calculating the loan amount.
            </p>
          }
          last={false}
        />

        {/* Plain white outline badge — secondary figure */}
        {/* LABEL CHANGE: "Minimum income required (annual)" → "Joint or sole minimum income required"
            Previously:
              label={
                <span>
                  Minimum income required{" "}
                  <span className="text-sm font-normal">(annual)</span>
                </span>
              } */}
        <ResultsBadge
          size="small"
          format="price"
          colorScheme={null}
          result={minimumIncome}
          label="Joint or sole minimum income required"
          help={
            <p className="text-md text-white">
              The minimum annual gross income typically required to qualify for
              this mortgage, based on a 5.5× income multiple.
            </p>
          }
          last={true}
        />
      </div>

      {/* Reset button REMOVED from here — moved to RentToMortgageCalculator.jsx (form card)
          Previously:
          <div className="mb-4 flex justify-end">
            <button ... onClick={onReset}>Reset</button>
          </div> */}

      <div className="mt-4">
        <CallToActions />
      </div>
    </div>
  );
}

export default RentToMortgageResults;
